<div class="conversations-view">
  <!-- Conversation Modal Component -->
  <ConversationModal
    :show="isModalVisible"
    :conversationDetails="selectedConversation"
    @close="isModalVisible = false"
  />

  <h1>Разговоры</h1>

  <div class="conversations-toolbar">
    <button class="filter-button">
      <img :src="require('@/assets/filter.svg')" alt="Фильтры" />
      Фильтры
    </button>
    <div class="search-container">
      <img
        :src="require('@/assets/search.svg')"
        alt="Поиск"
        class="search-icon"
      />
      <input
        type="text"
        class="search-input"
        placeholder="Поиск"
        v-model="searchPhoneNumber"
        @input="onPhoneNumberInput"
      />
    </div>
  </div>

  <!-- Content Wrapper -->
  <div class="content-wrapper">
    <div class="table-wrapper">
      <table class="conversations-table">
        <thead>
          <tr>
            <th>Пользователи</th>
            <th>Статус</th>
            <th>Дата и время</th>
            <th>Длительность</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(conversation, index) in conversations" :key="index">
            <td>
              <span class="userName">{{ conversation.name }}</span>
              <br />
              <span class="user-phone">{{ conversation.phone_number }}</span>
            </td>
            <td>
              <span
                :class="getStatusClass(conversation.call_type)"
                class="status-badge"
              >
                {{ conversation.call_type }}
              </span>
            </td>
            <td>
              <span class="date"
                >{{ new Date( new Date(conversation.start_time).getTime() + 5 *
                60 * 60 * 1000 ).toLocaleDateString() }}</span
              >
              <br />
              <span class="time"
                >{{ new Date( new Date(conversation.start_time).getTime() + 5 *
                60 * 60 * 1000 ).toLocaleTimeString() }}</span
              >
            </td>
            <td>
              <span class="duration">
                {{ calculateDuration( conversation.start_time,
                conversation.end_time ) }}
              </span>
            </td>
            <td>
              <button
                class="conversation-button"
                @click="openModal(conversation)"
              >
                <img :src="require('@/assets/transcript.svg')" alt="Разговор" />
                Разговор
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination">
    <button @click="prevPage" :disabled="currentPage === 1">Предыдущая</button>
    <span>Страница {{ currentPage }} из {{ totalPages }}</span>
    <button @click="nextPage" :disabled="currentPage === totalPages">
      Следующая
    </button>
  </div>
</div>
